/**
 * //////////////////////////////////////////////////
 * REDUCKSメインファイル
 * --------------------------
 *
 * セレクタ、オペレーション、サガ、リデューサを束ねるメインファイル。
 * Reducksの他のコンポーネント（notifications）と結合するために、主にducks/index.jsファイルにエクスポートされます。
 * ///////////////////////////////////////////////////
 */

import * as watchersSagas from './watchersSagas';

export const transferApproveWatcherSagas = Object.values(watchersSagas);
export {default as transferApproveOperations} from "./operations";
export {default as transferApproveTypes} from "./types";

export {transferApproveState, default as transferApproveReducer} from './reducers';
